<input
  type="file"
  [accept]="acceptedExtensions.join(',')"
  multiple
  [disabled]="!canAddMore"
  (change)="onFilesSelected($event)"
  class="form-control" />

@if (files.length > 0) {
  <div class="workblock-file-list">
    @for (fileToPreview of files; track fileToPreview.file; let i = $index) {
      <div class="workblock-file-item">
        <img [src]="fileToPreview.base64" class="workblock-file-thumbnail" alt="File preview" />
        <button
          type="button"
          class="btn-close workblock-file-remove"
          title="Remove"
          (click)="removeFile(i)">
        </button>
      </div>
    }
  </div>
}

@if (!canAddMore) {
  <div class="form-text">Maximum of {{ maxFiles }} files reached.</div>
}
